import { render, staticRenderFns } from "./IRLScore.vue?vue&type=template&id=49a5c2e5&scoped=true&"
import script from "./IRLScore.vue?vue&type=script&lang=js&"
export * from "./IRLScore.vue?vue&type=script&lang=js&"
import style0 from "./IRLScore.vue?vue&type=style&index=0&id=49a5c2e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5c2e5",
  null
  
)

export default component.exports